<script setup lang="ts">
interface Props {
  color?: string;
  icon?: boolean;
}

withDefaults(defineProps<Props>(), {
  color: 'primary',
  icon: false,
});
</script>

<template>
  <q-card
    class="relative-position full-height justify-between q-pa-none scroll"
  >
    <q-card-section class="q-pa-none full-height">
      <slot />
    </q-card-section>
    <q-space />
    <q-card-actions :class="`q-pa-none sticky-bottom bg-${color} z-100`">
      <slot name="footer"></slot>
    </q-card-actions>
  </q-card>
</template>

<style scoped lang="scss">
.q-pa-none {
  padding: 0 !important;
}
</style>
